<a href (click)="onClick.next($event); (false)"
  ><img src="/assets/layout/images/fanguru/FILTER_ICON.png"
/></a>
